var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collectOnlineMetrics.data)?_c('v-chart',{ref:"chart",staticClass:"online-chart",attrs:{"option":_vm.chartData,"autoresize":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }